import { FeedbackMetadataAccordion } from '@modules/feedback/components/FeedbackMetadata';
import { FeedbackMetadataField } from '@modules/feedback/types';
import { Divider, Stack } from '@mui/material';
import { ObjectType } from 'generated/graphql';
import { toTitleCase } from 'v2/utils/strings';

interface FeedbackMetadataGroupedByObjectIDProps {
  metadataFields: FeedbackMetadataField[];
  groupedByObjectID: Record<string, FeedbackMetadataField[]>;
  objectType: ObjectType;
  gridColumns?: number;
  feedbackID: string;
}

export const FeedbackMetadataGroupedByObjectID = ({
  metadataFields,
  groupedByObjectID,
  objectType,
  gridColumns,
  feedbackID,
}: FeedbackMetadataGroupedByObjectIDProps) => {
  return (
    <Stack>
      {Object.entries(groupedByObjectID).map(
        ([objectID, objectIDMetadataFields], index) => {
          const referencedMetadataField = metadataFields.find(
            (metadataField) =>
              metadataField.objectID === objectID && metadataField.isReference,
          );

          const title =
            referencedMetadataField?.values?.[0] ||
            `${toTitleCase(objectType.toString())} (${index + 1})`;

          return (
            <Stack key={objectID}>
              <FeedbackMetadataAccordion
                title={title}
                metadataFields={objectIDMetadataFields}
                gridColumns={gridColumns}
                feedbackID={feedbackID}
                objectType={objectType}
              />
              <Divider />
            </Stack>
          );
        },
      )}
    </Stack>
  );
};
